import { render, staticRenderFns } from "./Forte.vue?vue&type=template&id=19198a0a&scoped=true&"
import script from "./Forte.vue?vue&type=script&lang=js&"
export * from "./Forte.vue?vue&type=script&lang=js&"
import style0 from "./Forte.vue?vue&type=style&index=0&id=19198a0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19198a0a",
  null
  
)

export default component.exports